// src/utils/formatters.js

/**
 * Helper function to format number as accounting (no decimals, with thousand separators)
 * @param {string | number} value - The number to format.
 * @returns {string} Formatted number string.
 */
export const formatAccounting = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(String(value).replace(/[^0-9]/g, ''));
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0, // No decimal places
        maximumFractionDigits: 0, // No decimal places
    }).format(num);
};

/**
 * Helper function to format date and time from ISO string.
 * @param {string} isoString - The ISO date string.
 * @returns {string} Formatted date and time string.
 */
export const formatDateTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
    };
    return new Intl.DateTimeFormat('id-ID', options).format(date);
};
